import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import EmptyReview from '../../common/EmptyReview';
import ReviewableCard from '../../ReviewCard/Reviewable';
import ReviewableSkeleton from '../../ReviewSkeleton/ReviewableSkeleton';
import { review_page_common_style } from '../../styles';
import Text from 'components/base/Text';
import { useCompletedReviewList, useReviewableReviewList } from 'components/my-page/hooks';
import { is_completed_write_atom } from 'components/reviews/store/write';
import CompletedBottomSheet from 'components/reviews/write/CompletedBottomSheet';

/**
 * 마이페이지 [리뷰] - 작성가능한 리뷰탭
 * @component
 */
const Reviewable = () => {
  const { reviewable_list, max_review_point, has_shipped_item, review_count, is_loading, refetchReviewableList } =
    useReviewableReviewList();
  const { refetchCompletedList } = useCompletedReviewList();
  const [is_completed_write, setIsCompletedWrite] = useAtom(is_completed_write_atom);

  useEffect(() => {
    if (is_completed_write) {
      refetchReviewableList();
      refetchCompletedList();
    }
  }, [is_completed_write, refetchReviewableList, refetchCompletedList]);

  if (is_loading) {
    return <ReviewableSkeleton />;
  }

  if (has_shipped_item) {
    return (
      <SC.EmptyWrapper>
        <EmptyReview
          title='구매확정을 하고 리뷰를 작성해 주세요.'
          text={`구매확정하지 않은 상품이 있어요.\n구매확정을 하면, 리뷰를 작성할 수 있어요.\n‘주문 상세’ 페이지에서 구매확정이 가능해요.`}
          button_link='/orders'
          button_title='구매확정 하러가기'
        />
      </SC.EmptyWrapper>
    );
  }

  return (
    <>
      {review_count === 0 ? (
        <SC.EmptyWrapper>
          <EmptyReview title='작성 가능한 리뷰가 없습니다.' text='상품을 구매하고 리뷰를 작성해 보세요.' />
        </SC.EmptyWrapper>
      ) : (
        <SC.Container css={review_page_common_style}>
          <div className='text_info'>
            <Text variant='title6_medium' color='gray_secondary'>
              작성 가능한 리뷰 <label className='review_count'>{review_count}</label>
            </Text>
            <Text variant='body4_medium' color='gray_secondary' className='point'>
              모두 작성하면 <label>{max_review_point.toLocaleString('ko-KR')}P</label>
            </Text>
          </div>
          <div>
            {reviewable_list.map((item, index) => (
              <ReviewableCard key={index} item_info={item} />
            ))}
          </div>
        </SC.Container>
      )}
      <CompletedBottomSheet is_show={is_completed_write} close={() => setIsCompletedWrite(false)} />
    </>
  );
};

export default Reviewable;

const SC = {
  Container: styled.div`
    padding-top: 92px;
  `,
  EmptyWrapper: styled.div`
    padding-top: 92px;
  `,
};
